import { FormControl, FormLabel, FormErrorMessage } from '@chakra-ui/form-control';
import { Input } from '@chakra-ui/input';
import { Field } from 'formik';
import React from 'react';

type TextFieldType = 'password';

type TextFieldProps = {
  name: string;
  label: string;
  placeholder?: string;
  error: string | undefined;
  touched: boolean | undefined;
  type?: TextFieldType;
};

/**
 * @deprecated use `<TextInput />` instead
 */
export const TextField = ({ name, label, placeholder, touched, error, type }: TextFieldProps) => (
  <Field name={name}>
    {({ field }: any) => (
      <FormControl isInvalid={error !== undefined && touched}>
        <FormLabel htmlFor={name}>{label}</FormLabel>
        <Input {...field} type={type} id={name} placeholder={placeholder || label} />
        <FormErrorMessage>{error}</FormErrorMessage>
      </FormControl>
    )}
  </Field>
);
